import React from "react";

function EmptyList({ content, componentName }) {
  return (
    <div
      className={`${
        componentName === "shoppingList" ? "h-100" : "my-sm-5 py-sm-3"
      }  d-flex justify-content-center align-items-center flex-column text-center `}
      style={{
        minHeight: "10vh", // Make it fill the full viewport height
        width: "100%",
      }}
    >
      {/* <i className="display-1 text-body bi bi-bag-x"> </i> */}

      <div
        className="mt-1 mb-1 font-style"
        style={{
          whiteSpace: "normal",
          width: "100%",
          fontFamily:'Inter',
          fontWeight:400,
          color:'#676A79'
        }}
      >
        {content}
      </div>
    </div>
  );
}

export default EmptyList;
